import * as React from 'react'
import { Image, Text } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'

import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import api from '@api/api'
import Logger from '@utils/logger'

const AccountSignatureScreen = () => {
  const i18n = useI18n()
  const navigation = useNavigation()

  const user = useReducer(UserStore.store, (s) => s.user)

  const [signature, setSignature] = React.useState<FileDetailResponse>()

  React.useEffect(() => {
    if (user && user.signatureFileId) {
      api.files.get(user.signatureFileId).then(setSignature).catch(Logger.error)
    }
  }, [user])

  return (
    <Root centered onLeft={navigation.goBack} header={i18n.t('screens.account.signature.title')}>
      {!!signature ? (
        <Signature source={{ uri: signature.url }} resizeMode="contain" />
      ) : (
        <Error>{i18n.t('screens.account.signature.empty')}</Error>
      )}
    </Root>
  )
}

export default AccountSignatureScreen

const Signature = styled(Image)`
  flex: 1;
  width: 100%;
  border: 1px solid red;
`

const Error = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  margin: 24px;
`
